import graphql from "../../graphql";

export default {
  namespaced: true,
  state: {
    passwordStrength: 0,
    passwordKnown: false,
    email: "",
  },
  getters: {
    passwordStrength: state => state.passwordStrength,
    passwordKnown: state => state.passwordKnown,
  },
  actions: {
    calculatePasswordStrength: (context, data) => {
      graphql
        .query({ query: passwordCheckQuery(), variables: { password: data } })
        .then(response => {
          let passwordChecker = response.data.currentUser.checkPassword;
          context.commit("setPasswordStrength", passwordChecker.score);
          context.commit("setPasswordKnown", passwordChecker.known);
        });
    },
    setEmailAddress: (context, data) => {
      context.commit("setEmailAddress", data);
    },
  },
  mutations: {
    setPasswordStrength: (state, data) => {
      state.passwordStrength = data;
    },
    setPasswordKnown: (state, boolean) => {
      state.passwordKnown = boolean;
    },
    setEmailAddress: (state, email) => {
      state.email = email;
    },
  },
};

const passwordCheckQuery = () => `
  query CheckPassword($password: String!){
    currentUser {
      checkPassword(password: $password) {
        score
        known
      }
    }
  }
`;
